"use client";

import Image from "@/components/Image";
import { useState, useRef, useEffect } from "react";
const Message = () => {
  const [isHovered, setIsHovered] = useState(false);
  const [isTopHovered, setIsTopHovered] = useState(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isTopModalOpen, setIsTopModalOpen] = useState(false);
  const modalRef = useRef<HTMLDivElement>(null);

  const handleMouseEnter = () => {
    if (document.documentElement.clientWidth > 768) {
      // 原有悬停逻辑
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      setIsHovered(true);
    }
  };
  // 点击按钮打开弹窗
  const handleOnClick = () => {
    if (document.documentElement.clientWidth <= 768) {
      setIsModalOpen(true);
    }
  };

  // 点击空白处关闭弹窗
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        modalRef.current &&
        !modalRef.current.contains(event.target as Node)
      ) {
        setIsModalOpen(false);
      }
    };

    // 只有在弹窗打开时才添加事件监听
    if (isModalOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isModalOpen]);

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setIsHovered(false);
      setIsTopHovered(false);
    }, 100);
  };

  return (
    <>
      {/* 电脑端上部分悬浮弹窗 */}
      {isTopHovered && (
        <div
          className="fixed z-50 w-full max-w-[290px] h-[357px] bg-white rounded-xl shadow-[2px_4px_30px_0px_rgba(45,47,49,0.16)]"
          style={{
            right: "400px",
            bottom: "20%",
          }}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          {/* 上部分标题 */}
          <div className="w-full max-w-[290px] mx-auto h-[357px] flex flex-col gap-[30px] pt-[30px]">
            <h3
              className="w-full h-[22px] mx-auto  font-semibold text-[20px] leading-[22px] tracking-[1px] text-center "
              style={{ color: "rgba(0, 0, 0, 0.88)" }}
            >
              个人版人工在线客服
            </h3>

            {/* 下部分二维码区域 */}
            <div className="w-full max-w-[198px] h-[225px] mx-auto flex flex-col gap-[15px] items-center">
              {/* 二维码图片区域 */}
              <div className="w-full max-w-[198px] h-[190px] relative">
                <Image
                  src="/customer_left_09.png"
                  alt="二维码"
                  width={198}
                  height={190}
                  className="object-contain"
                />
              </div>

              {/* 文字区域 */}
              <div className="w-full h-[20px] flex gap-[2px] px-1">
                {/* 左侧logo */}
                <div className="w-full max-w-[22px] h-[20px] relative translate-y-[3px]">
                  <Image
                    src="/weixin 3.png"
                    alt="logo"
                    width={22}
                    height={20}
                    className="object-contain"
                  />
                </div>

                {/* 右侧文字 */}
                <div className="w-full h-[20px]">
                  <p className="whitespace-nowrap  font-normal text-[12px] leading-[20px] tracking-[1px] text-black">
                    微信扫码，仅限老师添加
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* 电脑端主弹窗 */}
      {isHovered && (
        <div
          className="fixed z-50 w-full max-w-[312px] h-[234px] bg-white rounded-xl shadow-[2px_4px_30px_0px_rgba(45,47,49,0.16)] overflow-hidden"
          style={{
            right: "calc(52px + 10px)",
            bottom: "20%",
          }}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          {/* 上部分 */}
          <div
            className="w-full h-[108px] p-6 rounded-t-xl hover:bg-[#F6F8FB] flex items-center cursor-pointer"
            onMouseEnter={() => setIsTopHovered(true)}
            onMouseLeave={() => setIsTopHovered(false)}
          >
            {/* 上左图片 */}
            <div className="w-full max-w-[62px] h-[60px] relative">
              <Image
                // src={IMAGE_URL + "qr_code.png"}
                src="/kefu.png"
                alt="二维码"
                width={62}
                height={60}
                className="object-contain"
              />
            </div>

            {/* 上右内容 */}
            <div className="ml-2 flex flex-col gap-[12px]">
              <h3
                className="w-full whitespace-nowrap  font-semibold text-[20px] leading-[22px] tracking-[1px] text-center"
                style={{ color: "rgba(0, 0, 0, 0.88)" }}
              >
                个人版在线人工客服
              </h3>
              <p
                className="w-full whitespace-nowrap  font-normal text-[16px] leading-[22px] tracking-[1px]"
                style={{ color: "rgba(153, 153, 153, 1)" }}
              >
                专业助教为您在线解答
              </p>
            </div>
          </div>

          {/* 下部分 */}
          <div
            className="w-full h-[126px] p-6 hover:bg-[#F6F8FB] flex items-center cursor-pointer"
            onClick={() =>
              window.open(
                "https://mifengjiaoyu.feishu.cn/share/base/form/shrcnPtXd6gal9wBuRiBUpjLrKb?prefill_%E7%BA%BF%E7%B4%A2%E6%9D%A5%E6%BA%90=%E5%AE%98%E7%BD%91&hide_%E7%BA%BF%E7%B4%A2%E6%9D%A5%E6%BA%90=1",
                "_blank",
              )
            }
          >
            {/* 下左图片 */}
            <div className="w-full max-w-[60px] h-[60px] relative">
              <Image
                // src={IMAGE_URL + " hone.png"}
                src="/caigou.png"
                alt="电话"
                width={60}
                height={60}
                className="object-contain"
              />
            </div>

            {/* 下右内容 */}
            <div className="ml-3 flex flex-col gap-[12px]">
              <h3
                className="w-full max-w-[179px]  font-semibold text-[20px] leading-[22px] tracking-[1px]"
                style={{ color: "rgba(0, 0, 0, 0.88)" }}
              >
                校园版采购填写
              </h3>
              <p
                className="w-full max-w-[179px]  font-normal text-[16px] leading-[22px] tracking-[1px]"
                style={{ color: "rgba(153, 153, 153, 1)" }}
              >
                填写您的需求，我们将第一时间与您联系
              </p>
            </div>
          </div>
        </div>
      )}

      {/* 移动端上部分悬浮弹窗 */}
      {isTopModalOpen && (
        <>
          {/* 蒙层 - 点击时关闭弹窗 */}
          <div
            className="fixed inset-0 z-55 bg-[rgba(0,0,0,0.6)]"
            onClick={() => setIsTopModalOpen(false)}
          />
          <div
            className="fixed z-60 w-full max-w-[290px] h-[357px] bg-white rounded-xl shadow-[2px_4px_30px_0px_rgba(45,47,49,0.16)]"
            style={{
              left: "50%", // 水平居中基准点
              top: "50%", // 垂直居中基准点
              transform: "translate(-50%, -50%)", // 向反方向偏移50%自身尺寸
            }}
          >
            {/* 上部分标题 */}
            <div className="w-full max-w-[290px] mx-auto h-[357px] flex flex-col gap-[30px] pt-[30px]">
              <h3
                className="w-full h-[22px] mx-auto  font-semibold text-[20px] leading-[22px] tracking-[1px] text-center "
                style={{ color: "rgba(0, 0, 0, 0.88)" }}
              >
                个人版人工在线客服
              </h3>

              {/* 下部分二维码区域 */}
              <div className="w-full max-w-[198px] h-[225px] mx-auto flex flex-col gap-[15px] items-center">
                {/* 二维码图片区域 */}
                <div className="w-full max-w-[198px] h-[190px] relative">
                  <Image
                    src="/customer_left_09.png"
                    alt="二维码"
                    width={198}
                    height={190}
                    className="object-contain"
                  />
                </div>

                {/* 文字区域 */}
                <div className="w-full h-[20px] flex gap-[2px] px-1">
                  {/* 左侧logo */}
                  <div className="w-full max-w-[22px] h-[20px] relative translate-y-[3px]">
                    <Image
                      src="/weixin 3.png"
                      alt="logo"
                      width={22}
                      height={20}
                      className="object-contain"
                    />
                  </div>

                  {/* 右侧文字 */}
                  <div className="w-full h-[20px]">
                    <p className="whitespace-nowrap  font-normal text-[12px] leading-[20px] tracking-[1px] text-black">
                      微信扫码，仅限老师添加
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {/* 移动端主弹窗 */}
      {isModalOpen && (
        <>
          {/* 蒙层 - 点击时关闭弹窗 */}
          <div
            className="fixed inset-0 z-40 bg-[rgba(0,0,0,0.6)]"
            onClick={() => setIsModalOpen(false)}
          />
          <div
            className="fixed z-50 w-full max-w-[436px]  [@media(max-width:530px)]:max-w-[80%] h-[234px] bg-white rounded-xl shadow-[2px_4px_30px_0px_rgba(45,47,49,0.16)] overflow-hidden"
            style={{
              left: "50%", // 水平居中基准点
              top: "50%", // 垂直居中基准点
              transform: "translate(-50%, -50%)", // 向反方向偏移50%自身尺寸
            }}
          >
            {/* 上部分 */}
            <div
              className="w-full h-[108px] p-6 rounded-t-xl hover:bg-[#F6F8FB] flex items-center cursor-pointer"
              onClick={() => setIsTopModalOpen(true)}
            >
              {/* 上左图片 */}
              <div className="w-full max-w-[62px] h-[60px] relative">
                <Image
                  // src={IMAGE_URL + "qr_code.png"}
                  src="/kefu.png"
                  alt="二维码"
                  width={62}
                  height={60}
                  className="object-contain"
                />
              </div>

              {/* 上右内容 */}
              <div className="ml-2 flex flex-col gap-[12px]">
                <h3
                  className="w-full whitespace-nowrap  font-semibold text-[20px] leading-[22px] tracking-[1px] text-center"
                  style={{ color: "rgba(0, 0, 0, 0.88)" }}
                >
                  个人版在线人工客服
                </h3>
                <p
                  className="w-full whitespace-nowrap  font-normal text-[16px] leading-[22px] tracking-[1px]"
                  style={{ color: "rgba(153, 153, 153, 1)" }}
                >
                  专业助教为您在线解答
                </p>
              </div>
            </div>

            {/* 下部分 */}
            <div
              className="w-full h-[126px] p-6 hover:bg-[#F6F8FB] flex items-center cursor-pointer"
              onClick={() =>
                window.open(
                  "https://mifengjiaoyu.feishu.cn/share/base/form/shrcnPtXd6gal9wBuRiBUpjLrKb?prefill_%E7%BA%BF%E7%B4%A2%E6%9D%A5%E6%BA%90=%E5%AE%98%E7%BD%91&hide_%E7%BA%BF%E7%B4%A2%E6%9D%A5%E6%BA%90=1",
                  "_blank",
                )
              }
            >
              {/* 下左图片 */}
              <div className="w-full max-w-[60px] h-[60px] relative">
                <Image
                  // src={IMAGE_URL + " hone.png"}
                  src="/caigou.png"
                  alt="电话"
                  width={60}
                  height={60}
                  className="object-contain"
                />
              </div>

              {/* 下右内容 */}
              <div className="ml-3 flex flex-col gap-[12px]">
                <h3
                  className="w-full  font-semibold text-[20px] leading-[22px] tracking-[1px]"
                  style={{ color: "rgba(0, 0, 0, 0.88)" }}
                >
                  校园版采购填写
                </h3>
                <p
                  className="w-full  font-normal text-[16px] leading-[22px] tracking-[1px]"
                  style={{ color: "rgba(153, 153, 153, 1)" }}
                >
                  填写您的需求，我们将第一时间与您联系
                </p>
              </div>
            </div>
          </div>
        </>
      )}

      {/* Message按钮 */}
      <div
        className="fixed z-50 flex items-center justify-center w-full max-w-[52px] h-[80px] bg-[#1DBA55] rounded-l-md cursor-pointer transition-all duration-300 hover:bg-[rgba(29,186,85,0.8)]"
        style={{
          top: "75%",
          right: "0",
          transform: "translateY(-50%)",
          boxShadow: "0 2px 10px rgba(0,0,0,0.15)",
        }}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onClick={() => {
          handleOnClick();
        }}
      >
        <div className="flex flex-col items-center justify-center w-full max-w-[30px] h-[56px] gap-[4px]">
          <div className="w-full max-w-[30px] h-[28px] flex items-center justify-center">
            <Image
              src="/message_11.png"
              alt="咨询图标"
              width={24}
              height={24}
              className={`w-6 h-6 object-contain transition-transform duration-300 ${isHovered ? "scale-110" : ""}`}
            />
          </div>

          <div className="w-full max-w-[30px] h-[24px] flex items-center justify-center">
            <span className=" font-normal text-[14px] leading-[24px] text-white">
              咨询
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default Message;
